import { FuelSign, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { FC, PropsWithChildren } from 'react';
import * as Styled from './styled';
import { IGenericState } from './types';

const GenericState: FC<PropsWithChildren<IGenericState>> = ({
  title,
  message,
  icon,
  iconColor,
  iconSize,
  testId,
  children,
}) => (
  <Styled.Wrapper data-testid={testId}>
    <FuelSign icon={icon} color={iconColor} size={iconSize} />
    <FuelTypography
      size="body-lg"
      color="neutral-strong"
      weight="bold"
      tag="h1"
      spacingTop={parseFloat(DS_TOKENS.spacing.km5)}
      spacingBottom={parseFloat(DS_TOKENS.spacing.km2)}
    >
      {title}
    </FuelTypography>
    <FuelTypography
      size="body-sm"
      color="neutral-default"
      weight="medium"
      tag="p"
      spacingBottom={parseFloat(DS_TOKENS.spacing.km1)}
    >
      {message}
    </FuelTypography>
    {children && (
      <FuelFlex
        defaultProps={{ width: '100%', gap: 'km4', customPadding: `${DS_TOKENS.spacing.km2} 0` }}
        testId="mobile-generic-state-child"
      >
        {children}
      </FuelFlex>
    )}
  </Styled.Wrapper>
);

export default GenericState;
